import { render, staticRenderFns } from "./HandoverToMe.vue?vue&type=template&id=080e3960&scoped=true"
import script from "./HandoverToMe.vue?vue&type=script&lang=js"
export * from "./HandoverToMe.vue?vue&type=script&lang=js"
import style0 from "./HandoverToMe.vue?vue&type=style&index=0&id=080e3960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e3960",
  null
  
)

export default component.exports